import OrderStatusesService from "../../../services/order-statuses.service";
import EventBus from "../../../EventBus";

export default {
  methods: {
    deleteStatus(id) {
      try {
        this.$dialog
          .confirm("Please confirm to continue")
          .then(async (dialog) => {
            console.log(dialog.data);

            const deleteStatus = await OrderStatusesService.softDeleteStatus(
              id
            );

            this.$toasted.show(deleteStatus.data.message, {
              type: "success",
              action: {
                text: "Cancel",
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                },
              },
              duration: 5000,
            });

            EventBus.$emit(
              "status-soft-deleted",
              deleteStatus.data.orderWithDetails
            );
          })
          .catch(() => {
            // Triggered when dialog is dismissed by user

            console.log("Clicked on cancel");
          });
      } catch (errors) {
        console.log(errors.response.data);
      }
    },
  },
};
